import { render, staticRenderFns } from "./exportConvenio.vue?vue&type=template&id=197428e2&scoped=true"
import script from "./exportConvenio.vue?vue&type=script&lang=js"
export * from "./exportConvenio.vue?vue&type=script&lang=js"
import style0 from "./exportConvenio.vue?vue&type=style&index=0&id=197428e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197428e2",
  null
  
)

export default component.exports